// app/_layout.tsx
// This file exists to satisfy Expo Router's requirement for a fallback layout.
// The actual implementations are in _layout.native.tsx and _layout.web.tsx
export { default, unstable_settings } from './_layout.web';